var _radialGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWebglobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab8954",
    cx: 65.025,
    cy: 5.037,
    r: 105.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#01b3f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#01b3f7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    d: "M113.28 28.59C98.3 7.63 73.88 5.55 64.05 5.4c-9.5-.14-29.7 3.02-44.46 18.19C8.64 34.84 3.32 48.85 3.52 65.04c.18 14.67 5.21 26.76 14.4 37.78c13.57 16.27 32.85 20.49 46.33 20.49c.38 0 .76 0 1.14-.01c13.14-.35 35.87-4.12 49.44-26.33c6-9.82 9.39-21.26 9.53-32.21c.23-17.66-6.84-30.25-11.08-36.17zm3.9 31.27l-11.5-.03c-.36-8.24-1.77-15.29-3.78-21.3l8.77.03c2.86 5.14 5.8 12.33 6.51 21.3zM10.82 67.6l11.99.03c.48 6.73 1.58 14.21 3.95 21.55h-9.75c-3.66-6.51-5.72-13.68-6.19-21.58zm57.04-55.86c3.54 1.33 13.82 6.04 21.36 18.76l-21.41-.06l.05-18.7zm-7.05.29v18.39l-22.01-.06c8.24-12.98 19.93-17.6 22.01-18.33zm0 26.39v21.31l-30.23-.07c.2-8.44 1.78-15.47 4.13-21.31l26.1.07zM22.52 59.63l-11.61-.03c.69-7.72 3.13-14.89 6.99-21.31l8.13.02c-2.09 6.01-3.45 13.07-3.51 21.32zm8.23 8.02l30.06.07v21.46H35c-2.16-5.87-3.71-12.97-4.25-21.53zm30.06 29.53v19.18c-4.06-1.3-14.65-5.84-22.15-19.18h22.15zm6.86 19.32l.14-19.32H90c-6.85 13.28-17.1 18.07-22.33 19.32zm.14-27.32V67.74l29.63.07c-.35 8.5-1.78 15.54-3.84 21.37H67.81zm0-29.44v-21.3l25.36.07c2.28 5.83 3.88 12.85 4.26 21.3l-29.62-.07zm37.48-29.19l-6.69-.02c-2.43-4.89-5.22-8.85-7.98-12.03c5.18 2.75 10.29 6.62 14.67 12.05zM37.5 18.97a55.794 55.794 0 0 0-7.99 11.35l-5.78-.02c.69-.79 1.4-1.57 2.13-2.33c3.7-3.78 7.66-6.73 11.64-9zM23.43 98.15c-.28-.32-.55-.65-.83-.97h7.33c2.14 4.47 4.88 8.74 8.38 12.6c-5.37-2.88-10.55-6.73-14.88-11.63zm67.06 12.18c3-3.65 6.72-8.09 8.78-13.15h6.52c-4.04 5.09-10.33 10.34-15.3 13.15zm20.47-21.15h-8.67c2.24-7.35 3.16-14.78 3.41-21.35l11.51.03c-.68 9.13-3.63 16.39-6.25 21.32z",
    fill: "url(#IconifyId17ecdb2904d178eab8954)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M93.65 39.75l-25.85-.08l.01-2.5l24.93.12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M60.81 39.65l-26.58-.06l.95-2.47l25.63.03z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M60.81 68.96l-29.98-.05l-.19-2.51l30.17.06z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M97.39 69.03l-29.58-.06v-2.5l29.7.11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M117.09 69.08l-11.46.01l.11-2.52l11.58.03z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M111.3 39.72l-8.99.05l-.8-2.42l8.56.06z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M60.81 98.41l-21.44-.01l-1.4-2.34l22.88-.14z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M89.37 98.34l-21.58.07l.02-2.5l22.85.07z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M30.52 98.36l-6.79.12l-2.01-2.28l7.81-.01z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M22.89 68.86l-12-.01l-.18-2.51l12.04.06z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M25.62 39.55l-8.44-.04l1.38-2.43l7.89-.02z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#188aff",
    d: "M104.73 98.46l-6.02-.05l1.06-2.36l6.9.04z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.84 30.31l.01-.09c.2-.29 3.45-7.47 9.64-12.71c6.29-5.33 12.12-6.93 12.37-7l-.05 2.65c-.06.02-5.2 1.31-11.16 6.11c-7.02 5.65-10.76 10.98-10.81 11.04z",
    fill: "#188aff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.23 30.51c-.03-.05-2.51-4.47-9.45-10.16c-5.51-4.51-11.86-7.34-11.93-7.37l.03-2.6c.3.12 6.88 2.97 12.52 8.03c6.36 5.7 8.66 11.69 8.78 11.91l.05.19z",
    fill: "#188aff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.27 30.52c-.03-.04-3.38-3.13-7.04-6.05c-3.46-2.77-5.91-3.93-5.95-3.96l-2.54-3.11c.2.1 5.83 2.92 9.4 6.02c3.53 3.07 5.94 6.8 6.06 6.95l.07.15z",
    fill: "#188aff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.74 30.3l.03-.1c.11-.13 2.1-3.23 5.56-6.46c4.21-3.92 8.89-5.73 9.05-5.82l-2.24 2.6c-.04.02-1.8.64-6.19 4.17c-3.5 2.82-6.18 5.58-6.21 5.61z",
    fill: "#188aff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.11 124.55c-41.05 0-54.65-34.41-54.79-34.75l.12.24c.14.33 15.32 32.01 54.67 32.01h.13c21.16-.04 34.42-8.85 41.83-16.24c8.05-8.03 12.3-15.49 12.33-15.57l.05-.1c-.13.34-11.93 34.33-54.2 34.41h-.14z",
    fill: "#188aff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebglobe);
export default __webpack_public_path__ + "static/media/icon-webglobe.1dabe7c640af4e0f1bf792b6ecb18611.svg";
export { ForwardRef as ReactComponent };